import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "./ricercaSegnalazioni.module.css";
import Table from "../../components/table/Table";
import Button from "../../components/button/Button";
import Spinner from "../../components/spinner/Spinner";
import SegnalazioniService from "../../services/SegnalazioniServices";
import SegnalazioniServices from "../../services/SegnalazioniServices";
import Utils from "../../utils/Utils";
import { isValid, parse } from "date-fns";
import OggettiUtili from "../../utils/OggettiUtili";
import Input from "../../components/textbox/Input";
import Calendar from "../../components/calendar/Calendar";
import $ from "jquery";
import toasterConfig from "../../config/toasterConfig";
import history from "../../utils/History";
import Modale from "../../components/modale/Modale";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import { states } from "../Wizard/States/States";
import SessioneUtente from "../../sessionManager/SessioneUtente";
import SelectAutocomplete from "../../components/selectAutocomplete/SelectAutocomplete";
import Ruoli from "../../utils/Ruoli";

class RicercaSegnalazioni extends Component {
    state = {
        rows: [],
        noSectionActive: true,
        loading: false,
        malattie: JSON.parse(sessionStorage.getItem("malattiePerDescrizione")),
        sections: [
            {
                malattia: "",
                cognome: "",
                nome: "",
                codFiscale: "",
                stp: "",
                dataSegnalazioneDa: "",
                dataSegnalazioneA: "",
                ulssSegnalazione: "",
            },
            {
                idSegnalazione: "",
            },
        ],
        sezioneAttiva: 0,
        disabledButtons: true,
        sezioneInErrore: [2],
        erroreCodiceFiscale: false,
        totalElements: 0,
        showTable: false,
        disabledTableButtons: true,
        page: 0,
        totalPages: 0,
        size: 10,
        segnalazioneSelezionata: null,
        listaSezioni: "00",

        malattieUtenteLaboratorio: JSON.parse(
            sessionStorage.getItem("malattieUtenteLaboratorioPerDescrizione")
        ),
    };

    cols = [
        { key: "checked", name: "", tipo: "checkbox", isRadio: true },
        {
            key: "idSegnalazioneLabel", // quello che mostri a video
            name: "Tables.RicercaSegnalazioni.id",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione", // il parametro passato
            valueKey: "idSegnalazione",      // aggiungi questo per dire: usa il vero valore
            state: { currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI },
        },
        {
            key: "malattia",
            name: "Tables.RicercaSegnalazioni.malattia",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: this.state.malattie,
            campo: "descrizione",
        },
        {
            key: "paziente",
            name: "Tables.RicercaSegnalazioni.paziente",
            sortDirection: "none",
        },
        {
            key: "ulssSegnalazione",
            name: "Tables.RicercaSegnalazioni.ulss",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {
            key: "dataSegnalazione",
            name: "Tables.RicercaSegnalazioni.data",
            sortDirection: "none",
            tipo: "data",
        },
        {
            key: "statoSegnalazione",
            name: "Tables.RicercaSegnalazioni.stato",
            sortDirection: "none",
            tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione,
        },
        {
            key: "scadenza",
            name: "Tables.Home.scadenza",
            sortDirection: "none",
        },
    ];

    segnalazioni = [];

    constructor(props) {
        super(props);

        this.riceviValore = this.riceviValore.bind(this);
        this.pulisciTutto = this.pulisciTutto.bind(this);
        this.disabilitaBottone = this.disabilitaBottone.bind(this);
        this.setErroreCodiceFiscale = this.setErroreCodiceFiscale.bind(this);
        this.executeSearch = this.executeSearch.bind(this);
        this.selezionaSegnalazione = this.selezionaSegnalazione.bind(this);
        this.inserisciNuova = this.inserisciNuova.bind(this);
        this.modificaSegnalazione = this.modificaSegnalazione.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.archiviaSegnalazione = this.archiviaSegnalazione.bind(this);
        this.controllaCampi = this.controllaCampi.bind(this);
    }

    selezionaSegnalazione(row, isChecked) {
        this.setState({
            segnalazioneSelezionata: row,
            disabledTableButtons: !isChecked,
        });
    }

    inserisciNuova() {
        let path = "/wizardSegnalazione";
        history.push({
            pathname: path,
            malattia: this.state.sections[0].malattia
                ? this.state.sections[0].malattia
                : null,
            nomePaziente: this.state.sections[0].nome
                ? this.state.sections[0].nome
                : null,
            cognomePaziente: this.state.sections[0].cognome
                ? this.state.sections[0].cognome
                : null,
            codiceFiscale: this.state.sections[0].codFiscale
                ? this.state.sections[0].codFiscale
                : null,
            stp: this.state.sections[0].stp
                ? this.state.sections[0].stp
                : null,
            ulssSegnalazione: this.state.sections[0].ulssSegnalazione
                ? this.state.sections[0].ulssSegnalazione
                : null,
            
        });
        sessionStorage.removeItem("parametriRicercaSegnalazioni");
    }

    modificaSegnalazione() {
        let path = "/wizardSegnalazione";
        let idSegnalazione = this.state.segnalazioneSelezionata.idSegnalazione;
        history.push({
            pathname: path,
            idSegnalazione: idSegnalazione,
            state: { currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI },
        });
    }

    archiviaSegnalazione() {
        let idSegnalazione = this.state.segnalazioneSelezionata.idSegnalazione;

        this.setState({ loading: true });

        SegnalazioniService.postArchiviaSegnalazione(idSegnalazione)
            .then(() => {
                let rows = this.state.rows;
                let i = Utils.checkObjectInArrayByObjectId(
                    rows,
                    "idSegnalazione",
                    idSegnalazione
                );
                let segnalazioneAggiornata = this.state.rows[i];
                segnalazioneAggiornata.statoSegnalazione =
                    OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice;
                segnalazioneAggiornata.checked = false;

                this.setState({ loading: false, rows: rows });
            })
            .catch(() => {
                console.log("[Error] GetFocolai in errore ");
                this.setState({ loading: false });
            });
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
    }

    componentDidMount() {
        Utils.scrollToTheTop();
        ToasterSingleton.instance().pulisci();
        ToasterSingleton.instance().sottoscrizione(this);
        sessionStorage.setItem("pathProvenienza", this.props.pathProvenienza)
        let paramsRicerca = sessionStorage.getItem(
            "parametriRicercaSegnalazioni"
        )
            ? JSON.parse(sessionStorage.getItem("parametriRicercaSegnalazioni"))
            : null;
        if (paramsRicerca) {
            let newSections = [
                {
                    malattia: paramsRicerca.malattia
                        ? paramsRicerca.malattia
                        : "",
                    cognome: paramsRicerca.cognome ? paramsRicerca.cognome : "",
                    nome: paramsRicerca.nome ? paramsRicerca.nome : "",
                    codFiscale: paramsRicerca.codiceFiscale
                        ? paramsRicerca.codiceFiscale
                        : "",
                    stp: paramsRicerca.stp ? paramsRicerca.stp : "",
                    dataSegnalazioneDa: paramsRicerca.dataDa
                        ? paramsRicerca.dataDa
                        : "",
                    dataSegnalazioneA: paramsRicerca.dataA
                        ? paramsRicerca.dataA
                        : "",
                    ulssSegnalazione: paramsRicerca.ulssSegnalazione
                        ? paramsRicerca.ulssSegnalazione
                        : "",
                },
                {
                    idSegnalazione: paramsRicerca.idSegnalazione
                        ? paramsRicerca.idSegnalazione
                        : "",
                },
            ];
            let size = paramsRicerca.size ? paramsRicerca.size : 10;
            this.setState({ sections: newSections, size: size });
            this.disabilitaBottone();
            this.sendRequest(paramsRicerca, true);
        }
        let obj = this;
        $(document).ready(() => {
            this.setCalendarIconToActiveSection();
            $(document).on("click", function (e) {
                switch (e.target.id) {
                    case "idMalattia":
                    case "idCognome":
                    case "idNome":
                    case "idStp":
                    case "idCodFiscale":
                    case "idSegnalazione":
                    case "dataSegnalazioneDa":
                    case "dataSegnalazioneA":
                    case "idButtonSearch":
                    case "idUlssSegnalazione":
                        break;
                    default: {
                        if (
                            e.target.id === "" ||
                            e.target.id.includes("bs-select")
                        ) {
                            break;
                        }
                        obj.setState({ noSectionActive: true });
                    }
                }
            });
        });
    }

    controllaCampi() {
        let sections = this.state.sections;

        if (
            sections[0].malattia != "" ||
            sections[0].cognome != "" ||
            sections[0].nome != "" ||
            sections[0].codFiscale != "" ||
            sections[0].stp != "" ||
            sections[0].dataSegnalazioneDa != "" ||
            sections[0].dataSegnalazioneA != "" ||
            sections[0].ulssSegnalazione != "" ||
            sections[1].idSegnalazione != ""
        ) {
            return false;
        } else {
            return true;
        }
    }

    riceviValore(field, event) {
        let newSections = this.state.sections;

        if (field === "malattia") {
            newSections[0].malattia = event.target.value;
        } else if (field === "nome") {
            newSections[0].nome = event.target.value;
        } else if (field === "cognome") {
            newSections[0].cognome = event.target.value;
        } else if (field === "codFiscale") {
            newSections[0].codFiscale = event.target.value;
            newSections[0].stp = "";
        } else if (field === "stp") {
            newSections[0].stp = event.target.value;
            newSections[0].codFiscale = "";
        } else if (field === "ulssSegnalazione") {
            newSections[0].ulssSegnalazione = event.target.value;
        } else if (field === "idSegnalazione") {
            newSections[1].idSegnalazione = event.target.value;
        } else if (field.currentTarget.id === "dataSegnalazioneDa") {
            newSections[0].dataSegnalazioneDa = field.target.value;
        } else if (field.currentTarget.id === "dataSegnalazioneA") {
            newSections[0].dataSegnalazioneA = field.target.value;
        }
        if (newSections[0].cognome === "") {
            newSections[0].nome = "";
        }

        this.setState({ sections: newSections });
        this.disabilitaBottone();
    }

    disabilitaBottone() {
        let sezione = this.state.sections;
        let disabled = false;

        if (
            (document.getElementById("idMalattia").value !== "" &&
                sezione[0].malattia &&
                sezione[0].malattia === undefined) ||
            (document.getElementById("idUlssSegnalazione") !== null &&
                document.getElementById("idUlssSegnalazione").value !== "" &&
                sezione[0].ulssSegnalazione &&
                sezione[0].ulssSegnalazione === undefined) ||
            (sezione[1].idSegnalazione !== "" &&
                !sezione[1].idSegnalazione.match(Utils.idSegnalazioneRegex)) ||
            sezione[1].idSegnalazione.startsWith(" ") ||
            (sezione[0].cognome !== "" &&
                (sezione[0].cognome.startsWith(" ") ||
                    sezione[0].cognome.endsWith(" ") ||
                    sezione[0].cognome.length < 2)) ||
            (sezione[0].cognome !== "" &&
                sezione[0].nome !== "" &&
                (sezione[0].nome.startsWith(" ") ||
                    sezione[0].nome.endsWith(" ") ||
                    sezione[0].nome.length < 2)) ||
            (sezione[0].codFiscale !== "" &&
                !Utils.isCFValid(sezione[0].codFiscale)) ||
            (sezione[0].stp !== "" && sezione[0].stp.startsWith(" ")) ||
            (sezione[0].dataSegnalazioneDa !== "" &&
                Utils.isDateInValid(
                    Utils.transformDateForBackend(
                        sezione[0].dataSegnalazioneDa
                    ),
                    "-"
                )) ||
            (sezione[0].dataSegnalazioneDa !== "" &&
                (Utils.isDateInValid(
                    Utils.transformDateForBackend(sezione[0].dataSegnalazioneA),
                    "-"
                ) ||
                    Utils.controlloPerDataSegnalazioneAPerError(
                        sezione[0].dataSegnalazioneA,
                        sezione[0].dataSegnalazioneDa
                    ))) ||
            (!sezione[0].malattia &&
                sezione[0].malattia === undefined &&
                !sezione[0].cognome &&
                !sezione[0].codFiscale &&
                !sezione[0].stp &&
                !sezione[0].dataSegnalazioneDa &&
                !sezione[1].idSegnalazione &&
                !sezione[0].ulssSegnalazione
            )
        ) {
            disabled = true;
        }
        this.setState({ disabledButtons: disabled });
    }

    setErroreCodiceFiscale(value) {
        this.setState({ erroreCodiceFiscale: value });
    }

    setCalendarIconToActiveSection() {
        $("#da .input-group-addon").click(() => {
            this.attivaSezione({ target: { id: "idDataSegnalazioneDa" } });
        });

        $("#da .input-group-addon").css("margin-right", 0);
        $("#da .input-group").css("padding-right", "15px");

        $("#a .input-group-addon").click(() => {
            this.attivaSezione({ target: { id: "idDataSegnalazioneA" } });
        });

        $("#a .input-group-addon").css("margin-right", 0);
        $("#a .input-group").css("padding-right", "15px");
    }

    componentDidUpdate() {
        sessionStorage.setItem("pathProvenienza", this.props.pathProvenienza)
        $("#div_idMalattia button").click(() => {
            this.attivaSezione({ target: { id: "idMalattia" } });
        });
    }

    attivaSezione(event) {
        let newSections = [
            {
                malattia: "",
                cognome: "",
                nome: "",
                codFiscale: "",
                stp: "",
                dataSegnalazioneDa: "",
                dataSegnalazioneA: "",
                ulssSegnalazione: ""
            },
            {
                idSegnalazione: "",
            },
        ];

        switch (event.target.id) {
            case "idMalattia":
            case "idCognome":
            case "idNome":
            case "idStp":
            case "idCodFiscale":
            case "idDataSegnalazioneDa":
            case "idDataSegnalazioneA":
            case "idUlssSegnalazione":
                newSections[0] = { ...this.state.sections[0] };
                this.state.sections = { ...newSections };
                this.setState({
                    sezioneAttiva: 1,
                    noSectionActive: false,
                    sezioneInErrore: {},
                });
                break;
            case "idSegnalazione":
                document.getElementById("idMalattia").value = "";
                $(document).ready(function () {
                    $(".selectpicker").selectpicker("refresh");
                });

                this.state.sections = { ...newSections };
                newSections[1] = { ...this.state.sections[1] };
                this.state.sections = { ...newSections };

                this.setState({
                    sezioneAttiva: 2,
                    noSectionActive: false,
                    sezioneInErrore: {},
                });
                break;
        }
    }

    pulisciTutto() {
        let cleaned = [
            {
                malattia: "",
                cognome: "",
                nome: "",
                codFiscale: "",
                stp: "",
                dataSegnalazioneDa: "",
                dataSegnalazioneA: "",
                ulssSegnalazione: "",
            },
            {
                idSegnalazione: "",
            },
        ];

        this.setState({
            sections: cleaned,
            sezioneInErrore: {},
            sezioneAttiva: 0,
            noSectionActive: true,
            disabledButtons: true,
            showTable: false,
            page: 0,
        });

        document.getElementById("idMalattia").value = "";
        $(document).ready(function () {
            $(".selectpicker").selectpicker("refresh");
        });
        sessionStorage.removeItem("parametriRicercaSegnalazioni");
    }

    checkBlockError() {
        let err = [];
        let that = this;

        switch (this.state.sezioneAttiva) {
            case 1:
                if (
                    this.state.sections[0].malattia &&
                    this.state.sections[0].malattia.length === 0 &&
                    this.state.sections[0].ulssSegnalazione &&
                    this.state.sections[0].ulssSegnalazione.length === 0 &&
                    this.state.sections[0].cognome &&
                    this.state.sections[0].cognome.length === 0 &&
                    this.state.sections[0].codFiscale &&
                    this.state.sections[0].codFiscale.length === 0 &&
                    this.state.sections[0].stp &&
                    this.state.sections[0].stp.length === 0 &&
                    this.state.sections[0].idSegnalazione &&
                    this.state.sections[0].idSegnalazione.length === 0 &&
                    (!isValid(parse(this.state.sections[0].dataSegnalazioneDa, "dd/MM/yyyy", new Date())) ||
                        !isValid(parse(this.state.sections[0].dataSegnalazioneA, "dd/MM/yyyy", new Date())))
                ) {
                    err[1] = true;
                    that.setState({ sezioneInErrore: err });
                } else that.setState({ sezioneInErrore: err });
                break;

            case 2:
                if (this.state.sections[1].idSegnalazione.length === 0) {
                    err[2] = true;
                    that.setState({ sezioneInErrore: err });
                } else that.setState({ sezioneInErrore: err });
                break;
        }
    }

    isValidForm() {
        if (
            !(
                (this.state.sezioneAttiva === 1 &&
                    this.state.sezioneInErrore[1]) ||
                (this.state.sezioneAttiva === 2 &&
                    this.state.sezioneInErrore[2])
            )
        ) {
            return true;
        }
        return false;
    }

    executeSearch() {
        let that = this;

        let scrollToError = function () {
            let y;
            switch (that.state.sezioneAttiva) {
                case 1:
                    y = document
                        .getElementById("idMalattia")
                        .getBoundingClientRect().top;
                    break;
                case 2:
                    y = document
                        .getElementById("idSegnalazione")
                        .getBoundingClientRect().top;
                    break;
            }

            window.scroll(0, y);
        };

        this.checkBlockError();

        setTimeout(function () {
            if (that.isValidForm()) {
                that.setState({ loading: true });
                let params = that.buildParams();
                params.page = 0;
                that.sendRequest(params, true);
                sessionStorage.setItem(
                    "parametriRicercaSegnalazioni",
                    JSON.stringify(params)
                );
            } else {
                scrollToError();
            }
        }, 50);
    }

    sendRequest(params, notPagination) {
        if (notPagination)
            this.setState({ loading: true, disabledTableButtons: true });
        else
            this.setState({ loading: true});

        SegnalazioniService.getSegnalazioni(params)
            .then((data) => {
                if (!data.data.content || data.data.content.length === 0) {
                    this.aggiungiToaster();
                }
                let res = SegnalazioniService.mapGetSegnalazioni(data);
                let newState = {
                    rows: res,
                    totalElements: data.data.totalElements,
                    showTable: true,
                    totalPages: data.data.totalPages,
                    loading: false
                };

                if (params.size && params.size !== this.state.size) {
                    newState["size"] = params.size;
                }
                if (
                    (params.page || params.page === 0) &&
                    params.page !== this.state.page
                ) {
                    newState["page"] = params.page;
                }

                this.setState(newState);
            })
            .catch((reason) => {
                let state = {
                    rows: [],
                    totalElements: 0,
                    showTable: true,
                    loading: false,
                    page: 0,
                };
                if (params.size && params.size !== this.state.size) {
                    state["size"] = params.size;
                }
                if (
                    (params.page || params.page === 0) &&
                    params.page !== this.state.page
                ) {
                    state["page"] = params.page;
                }
                console.log("[Error] GetSegnalazioni in errore ");
                this.setState(state);
            });
    }

    aggiungiToaster() {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.informational,
            text: ["Toasters.Messages.no_result"],
            timestamp: Date.now(),
        });
    }

    buildParams(sort, direction, page, size) {
        let stato = this.state;
        let ulssIdSegnalazione = stato.sections[1].idSegnalazione
            ? stato.sections[1].idSegnalazione.substring(0, 6)
            : null;
        let params = {
            ulss:
                SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp_HIV.descrizione
                    ? SessioneUtente.getInstance().ulss
                    : ulssIdSegnalazione,
        };
        if (stato.sections[0].malattia) {
            params["malattia"] = stato.sections[0].malattia;
        }
        if (stato.sections[0].cognome) {
            params["cognome"] = stato.sections[0].cognome.toUpperCase();
        }
        if (stato.sections[0].nome) {
            params["nome"] = stato.sections[0].nome.toUpperCase();
        }
        if (stato.sections[0].codFiscale) {
            params["codiceFiscale"] =
                stato.sections[0].codFiscale.toUpperCase();
        }
        if (stato.sections[0].stp) {
            params["stp"] = stato.sections[0].stp.toUpperCase();
        }
        if (stato.sections[0].dataSegnalazioneDa) {
            params["dataDa"] = Utils.transformDateForBackend(
                stato.sections[0].dataSegnalazioneDa.toUpperCase()
            );
        }
        if (stato.sections[0].dataSegnalazioneA) {
            params["dataA"] = Utils.transformDateForBackend(
                stato.sections[0].dataSegnalazioneA.toUpperCase()
            );
        }
        if (stato.sections[0].ulssSegnalazione) {
            params["ulssSegnalazione"] = stato.sections[0].ulssSegnalazione;
        }
       
        if (stato.sections[1].idSegnalazione) {
            params["idSegnalazione"] =
                stato.sections[1].idSegnalazione.toUpperCase();
        }

        params.page = page;

        params.order = direction;

        params.sort = sort;

        params.isRicerca = true;

        return Utils.removeEmptyValueFromObject(params);
    }

    changePageTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size;
            } else {
                params.size = size;
            }
        }

        this.sendRequest(params, false);
        sessionStorage.setItem(
            "parametriRicercaSegnalazioni",
            JSON.stringify(params)
        );
    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);

        if (size != null) params.size = size;

        this.sendRequest(params, false);
        sessionStorage.setItem(
            "parametriRicercaSegnalazioni",
            JSON.stringify(params)
        );
    }

        inserisciNuovaList(row) {
                let path = "/wizardSegnalazione";
        
                SegnalazioniServices.getSingolaSegnalazioneLIS(row.id).then((data) => {
            // Salva i dati necessari nello storage per passarli alla nuova pagina
                    history.push({
                        pathname: path,
                       
                        malattia: data.data.infoLaboratorio.codiceSirmi.split('-')[0],
                        nomePaziente: data.data.anagNotificationLis.nome,
                        cognomePaziente: data.data.anagNotificationLis.cognome,
                        codiceFiscale: data.data.anagNotificationLis.cfPaziente,
                        stp: data.data.anagNotificationLis.stp,
                        ulssSegnalazione: data.data.infoLaboratorio.ulss,
                        comuneSegnalazione:data.data.infoLaboratorio.istatComuneLaboratorio,
                        dataSegnalazione:Utils.transformTimeStampForFrontend(data.data.dataSegnalazione),
                        dataDiNascita:Utils.transformTimeStampForFrontend(data.data.anagNotificationLis.dttNascita),
                        sesso:data.data.anagNotificationLis.sesso,
                        comuneResidenza:data.data.anagNotificationLis.cittaResidenza?data.data.anagNotificationLis.cittaResidenza:data.data.anagNotificationLis.paeseResidenza,
                        indirizzoResidenza: data.data.anagNotificationLis.indirizzoResidenza? (data.data.anagNotificationLis.indirizzoResidenza + (data.data.anagNotificationLis.civicoResidenza && true? " " + data.data.anagNotificationLis.civicoResidenza : "")): "",
                        comuneDomicilio:data.data.anagNotificationLis.cittaDomicilio?data.data.anagNotificationLis.cittaDomicilio:data.data.anagNotificationLis.paeseDomicilio,
                        indirizzoDomicilio:data.data.anagNotificationLis.indirizzoDomicilio? (data.data.anagNotificationLis.indirizzoDomicilio + (data.data.anagNotificationLis.civicoDomicilio && true? " " + data.data.anagNotificationLis.civicoDomicilio : "")) : "",
                        formPazienteSpecifico:false,
                        idLisSegnalazione:data.data.id,
                        comuneNascita:data.data.anagNotificationLis.cittaNascita?data.data.anagNotificationLis.cittaNascita:data.data.anagNotificationLis.paeseNascita,
                        infoLaboratorio:'1',
                        tipoLaboratorio:'R',
                        dataEsame:data.data.infoLaboratorio.dttReferto,
                        dataPrelievo:data.data.infoLaboratorio.dttPrelievo,
                        listaDettaglioLab:[data.data.infoLaboratorio.codiceSirmi.split('-')[1]],
                        state: { currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI },
                    });
    
                    
                }).catch((error) => {
                    console.error("Errore durante il recupero della segnalazione:", error);
                });
                sessionStorage.removeItem("parametriRicercaSegnalazioni");
            }

    render() {
        const { t } = this.props;
        const bluButton = "btnBlu";
        const whiteButton = "btnWhite";
        const malattieDaEliminare = [
            "USUTU",
            "MALATTIA BATTERICO INVASIVA DA STREPTOCOCCUS PYOGENES",
            "MENINGITE DA BATTERI NON SPECIFICATI",
            "MENINGITE DA CRIPTOCOCCO",
            "MENINGITE DA LEPTOSPIRA",
            "MENINGITE DA TRIPANOSOMA",
            "MENINGITE SIFILITICA",
            "MENINGITE STAFILOCOCCICA",
            "MENINGITE STREPTOCOCCICA",
            "MENINGITE DA PNEUMOCOCCO (S.Pneumoniae)",
            "MENINGITE MENINGOCOCCO (N.Meningitidis)",
            "MENINGITE DA EMOFILO (H.Influenzae)",
            "MALATTIA BATTERICO INVASIVA DA STAPHYLOCOCCUS CAPITIS",
            "MALATTIA BATTERICO INVASIVA CON AGENTE IN ATTESA DI IDENTIFICAZIONE",
            "MALATTIA BATTERICO INVASIVA DA AGENTE NON IDENTIFICATO",
            "MALATTIA BATTERICO INVASIVA DA ALTRI AGENTI",
            "MALATTIA BATTERICO INVASIVA DA ALTRI BATTERI GRAM-",
            "MALATTIA BATTERICO INVASIVA DA ENTEROCOCCUS FAECALIS",
            "MALATTIA BATTERICO INVASIVA DA ESCHERICHIA COLI",
            "MALATTIA BATTERICO INVASIVA DA EMOFILO (H.Influenzae)",
            "MALATTIA BATTERICO INVASIVA DA KLEBSIELLA PNEUMONIAE",
            "MALATTIA BATTERICO INVASIVA DA KLEBSIELLA SPP",
            "MALATTIA BATTERICO INVASIVA DA LEPTOSPIRA SPP",
            "MALATTIA BATTERICO INVASIVA DA LISTERIA MONOCYTOGENES",
            "MALATTIA BATTERICO INVASIVA DA MYCOBACTERIUM TUBERCOLISIS",
            "MALATTIA BATTERICO INVASIVA DA MENINGOCOCCO (N.Meningitidis)",
            "MALATTIA BATTERICO INVASIVA DA PSEUDOMONAS AERUGINOSA",
            "MALATTIA BATTERICO INVASIVA DA STAPHYLOCOCCUS AUREUS",
            "MALATTIA BATTERICO INVASIVA DA STREPTOCOCCUS B",
            "MALATTIA BATTERICO INVASIVA DA PNEUMOCOCCO (S.Pneumoniae)"
        ];

        malattieDaEliminare.forEach(malattia => {
            delete this.state.malattie[malattia];
        });

        const firstSection = (
            <div
                className={styles.fieldContainer}
                style={{
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 1
                            ? "1"
                            : "0.3",
                }}
                onClick={() => {
                    this.attivaSezione({ target: { id: "idMalattia" } });
                }}
            >
                <p className={styles.labelHeader}>
                    {t("GestioneSegnalazioni.ricerca.malattia")}{" "}
                    <span className={styles.mandatoryColor}>*</span>
                </p>
                <SelectAutocomplete
                    id={"idMalattia"}
                    field={"malattia"}
                    newSelect={true}
                    onChange={this.riceviValore}
                    value={this.state.sections[0].malattia}
                    functionMap={Utils.mapToArray(
                        SessioneUtente.getInstance().ruoliUtente ===
                            Ruoli.Operatore_Laboratorio.descrizione
                            ? this.state.malattieUtenteLaboratorio
                            : this.state.malattie
                    ).map((oggetto) => {
                        return (
                            <option value={oggetto.codice}>
                                {oggetto.codDesc}
                            </option>
                        );
                    })}
                ></SelectAutocomplete>
            </div>
        );

        const secondSection = (
            <div
                className={styles.responsiveGrid}
                style={{
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 1
                            ? "1"
                            : "0.3",
                }}
            >
                <div
                    className={styles.fieldContainer}
                    onClick={() =>
                        this.attivaSezione({ target: { id: "idCognome" } })
                    }
                >
                    <p className={styles.labelHeader}>
                        {t("GestioneSegnalazioni.ricerca.cognome")}{" "}
                        <span className={styles.mandatoryColor}>*</span>
                    </p>
                    <Input
                        id={"idCognome"}
                        onChange={this.riceviValore}
                        field={"cognome"}
                        onValidate={
                            this.state.sezioneAttiva === 1 &&
                            !Utils.isObjectEmpty(this.state.sections[0].cognome)
                                ? this.state.sections[0].cognome.replace(
                                      / +/g,
                                      ""
                                  ).length === 0 ||
                                  this.state.sections[0].cognome.startsWith(" ")
                                    ? 1
                                    : 2
                                : 2
                        }
                        errorMessage={"Cognome non valido"}
                        value={this.state.sections[0].cognome}
                        placeholder={t("GestioneSegnalazioni.ricerca.cognome")}
                    />
                </div>
                <div
                    className={styles.fieldContainer}
                    onClick={() =>
                        this.attivaSezione({ target: { id: "idNome" } })
                    }
                >
                    <span className={"labelHeader"}>
                        {t("GestioneSegnalazioni.ricerca.nome")}
                    </span>

                    <Input
                        id={"idNome"}
                        onChange={this.riceviValore}
                        field={"nome"}
                        onValidate={
                            this.state.sezioneAttiva === 1 &&
                            !Utils.isObjectEmpty(this.state.sections[0].nome)
                                ? this.state.sections[0].nome.replace(/ +/g, "")
                                      .length === 0 ||
                                  this.state.sections[0].nome.startsWith(" ")
                                    ? 1
                                    : 2
                                : 2
                        }
                        errorMessage={"Nome non valido"}
                        disabled={!this.state.sections[0].cognome}
                        value={this.state.sections[0].nome}
                        placeholder={t("GestioneSegnalazioni.ricerca.nome")}
                    />
                </div>
            </div>
        );

        const thirdSection = (
            <div
                style={{
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 1
                            ? "1"
                            : "0.3",
                }}
                onClick={() =>
                    this.attivaSezione({ target: { id: "idCodFiscale" } })
                }
            >
                <p>
                    {t("GestioneSegnalazioni.ricerca.cf")}{" "}
                    <span className={styles.mandatoryColor}>*</span>
                </p>
                <Input
                    id={"idCodFiscale"}
                    onChange={this.riceviValore}
                    field={"codFiscale"}
                    onValidate={
                        this.state.sezioneAttiva === 1 &&
                        this.state.sections[0].codFiscale
                            ? Utils.isCFValid(this.state.sections[0].codFiscale)
                                ? 2
                                : 1
                            : 2
                    }
                    errorMessage={
                        "Codice fiscale non valido. Inserire un codice fiscale valido"
                    }
                    value={this.state.sections[0].codFiscale}
                    disabled={this.state.sections[0].stp}
                    placeholder={t("GestioneSegnalazioni.ricerca.cf")}
                ></Input>
            </div>
        );

        const forthSection = (
            <div
                style={{
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 1
                            ? "1"
                            : "0.3",
                }}
                onClick={() => this.attivaSezione({ target: { id: "idStp" } })}
            >
                <p className={styles.labelHeader}>
                    {t("GestioneSegnalazioni.ricerca.stp")}{" "}
                    <span className={styles.mandatoryColor}>*</span>
                    <span
                        className={"fontSize12"}
                        style={{ marginLeft: "3px" }}
                    >
                        {t("GestioneSegnalazioni.ricerca.cittadini_stranieri")}
                    </span>
                </p>

                <Input
                    id={"idStp"}
                    onChange={this.riceviValore}
                    field={"stp"}
                    value={this.state.sections[0].stp}
                    placeholder={t("GestioneSegnalazioni.ricerca.stp")}
                    disabled={this.state.sections[0].codFiscale}
                    onValidate={
                        this.state.sezioneAttiva === 1 &&
                        !Utils.isObjectEmpty(this.state.sections[0].stp)
                            ? this.state.sections[0].stp.replace(/ +/g, "")
                                  .length === 0 ||
                              this.state.sections[0].stp.startsWith(" ")
                                ? 1
                                : 2
                            : 0
                    }
                    errorMessage={"STP non valido"}
                ></Input>
            </div>
        );

        const dataSegnalazioneSection = (
            <div
                style={{
                    marginBottom: "0.5rem",
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 1
                            ? "1"
                            : "0.3",
                }}
            >
                <p className={styles.labelHeader}>
                    {t("GestioneSegnalazioni.ricerca.data_segnalazione")}{" "}
                    <span className={styles.mandatoryColor}>*</span>
                </p>

                <div>
                    <div
                        className={styles.dataSegnalazioneGroup}
                        style={{ marginBottom: "0.5rem" }}
                        onClick={() =>
                            this.attivaSezione({
                                target: { id: "idDataSegnalazioneDa" },
                            })
                        }
                    >
                        <label className={styles.labelStyle} htmlFor="da">
                            {t("Utils.da")}
                        </label>
                        <div id="da">
                            <Calendar
                                id={"dataSegnalazioneDa"}
                                value={
                                    this.state.sections[0].dataSegnalazioneDa
                                }
                                onChange={this.riceviValore}
                                field={"dataSegnalazioneDa"}
                                errorMessage={
                                    Utils.isDateInValid(
                                        this.state.sections[0]
                                            .dataSegnalazioneDa
                                    )
                                        ? "Data non valida. Inserire 'data segnalazione Da' valida"
                                        : ""
                                }
                                error={
                                    Utils.isDateInValid(
                                        Utils.transformDateForBackend(
                                            this.state.sections[0]
                                                .dataSegnalazioneDa
                                        ),
                                        "-"
                                    ) &&
                                    this.state.sections[0]
                                        .dataSegnalazioneDa !== ""
                                }
                            ></Calendar>
                        </div>
                    </div>

                    <div
                        className={styles.dataSegnalazioneGroup}
                        onClick={() =>
                            this.attivaSezione({
                                target: { id: "idDataSegnalazioneA" },
                            })
                        }
                    >
                        <label className={styles.labelStyle} htmlFor="a">
                            {t("Utils.a")}
                        </label>
                        <div id="a">
                            <Calendar
                                id={"dataSegnalazioneA"}
                                value={this.state.sections[0].dataSegnalazioneA}
                                field={"dataSegnalazioneA"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.controlloPerDataSegnalazioneAPerMessageError(
                                    this.state.sections[0].dataSegnalazioneA,
                                    this.state.sections[0].dataSegnalazioneDa
                                )}
                                error={Utils.controlloPerDataSegnalazioneAPerError(
                                    this.state.sections[0].dataSegnalazioneA,
                                    this.state.sections[0].dataSegnalazioneDa
                                )}
                            ></Calendar>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sixthSection = (
            <div
                className={styles.fieldContainer}
                style={{
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 2
                            ? "1"
                            : "0.3",
                }}
                onClick={() =>
                    this.attivaSezione({ target: { id: "idSegnalazione" } })
                }
            >
                <p className={styles.labelHeader}>
                    {t("GestioneSegnalazioni.ricerca.id_segnalazione")}{" "}
                    <span className={styles.mandatoryColor}>*</span>
                </p>
                <Input
                    id={"idSegnalazione"}
                    onChange={this.riceviValore}
                    field={"idSegnalazione"}
                    value={this.state.sections[1].idSegnalazione}
                    placeholder={t(
                        "GestioneSegnalazioni.ricerca.id_segnalazione"
                    )}
                    onValidate={
                        this.state.sezioneAttiva === 2 &&
                        this.state.sections[1].idSegnalazione !== ""
                            ? Utils.checkIdSegnalazione(
                                  this.state.sections[1].idSegnalazione
                              )
                                ? 2
                                : 1
                            : 2
                    }
                    errorMessage={
                        "Id segnalazione non valido. Inserire un id segnalazione valido"
                    }
                ></Input>
            </div>
        );

        const ulssSection = (
            <div
                style={{
                    opacity:
                        this.state.noSectionActive === true ||
                        this.state.sezioneAttiva === 1
                            ? "1"
                            : "0.3",
                }}
                onClick={() => {
                    this.attivaSezione({ target: { id: "ulssSegnalazione" } });
                }}
            >
                <p className={styles.labelHeader}>
                    {t("GestioneSegnalazioni.ricerca.ulssSegnalazione")}{" "}
                    <span className={styles.mandatoryColor}>*</span>
                </p>
                <SelectAutocomplete
                    id={"idUlssSegnalazione"}
                    field={"ulssSegnalazione"}
                    newSelect={true}
                    onChange={this.riceviValore}
                    value={this.state.sections[0].ulssSegnalazione}
                    functionMap={Object.keys(OggettiUtili.Ulss).map((codice) => {
                        return (
                            <option value={codice}>
                                {OggettiUtili.Ulss[codice]}
                            </option>
                        );
                    })}
                />
            </div>
        );

        const form = (
            <div className={styles.contenitoreRicerca}>
                {firstSection}

                {secondSection}

                <div className={styles.responsiveGridPlus}>
                    <div className={styles.fieldContainer}>{thirdSection}</div>
                    <div className={styles.fieldContainer}>{forthSection}</div>
                </div>

                <div className={styles.responsiveGrid}>
                    {dataSegnalazioneSection}
                    {sixthSection}
                </div>

                {SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Laboratorio.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Regionale.descrizione ? (
                    <div className={styles.responsiveGridPlus}>
                        <div className={styles.fieldContainer}>{ulssSection}</div>
                    </div>
                ) : (
                    <div/>
                )}
            </div>
        );

        const tableDiv = (
            <div id="contenitoreTabella" className={styles.contenitoreTabella}>
                <div id="contenitoreTabella" className={styles.contenitoreTabella}>
                <Table
                    cols={this.cols}
                    rows={this.state.rows.map(row => {
                        // Ripulisce eventuali spazi multipli
                        const cleanedId = row.idSegnalazione
                            ? row.idSegnalazione.trim().replace(/\s+/g, ' ')
                            : '';

                        const checked = !!(this.state.segnalazioneSelezionata && row.id
                            && this.state.segnalazioneSelezionata.id === row.id);

                        return {
                            ...row,
                            idSegnalazioneLabel:
                                cleanedId === 'null null'
                                    ? 'Prendere in carico'
                                    : row.idSegnalazione,
                            checked:checked
                        };
                    })}
                    title={t("GestioneSegnalazioni.ricerca.titolo_tabella")}
                    empty={this.state.rows && this.state.rows.length === 0}
                    emptyMsg={t("Tables.RicercaSegnalazioni.noSegnalazioni")}
                    lengthEditable={true}
                    onSelectCheckbox={this.selezionaSegnalazione}
                    totalElements={this.state.totalElements}
                    bigTable={true}
                    totalPages={this.state.totalPages}
                    page={this.state.page}
                    inserimentoSegnalazioni = {this.inserisciNuovaList}
                    changePage={this.changePageTable}
                    changePagination={this.changePaginationTable}
                    tableLenght={this.state.size}
                />
            </div>

            </div>
        );

        const spinnerDiv = (
            <div>
                <Spinner />
            </div>
        );

        const tableButtonsDiv = (
            <div className={"row"} style={{ marginTop: "5rem" }}>
                <div className={"col-sm-12 col-lg-3 mx-lg-auto"}>
                    <Button
                        text={t("Buttons.modify")}
                        disabled={this.state.disabledTableButtons}
                        onClick={this.modificaSegnalazione}
                        className={"btnWhite"}
                        style={{
                            height: "3rem",
                            marginTop: "1rem",
                            width: "100%",
                        }}
                    ></Button>
                </div>
                <Modale
                    containerClass={"col-sm-12 col-lg-3 mx-lg-auto"}
                    classes="btnWhite"
                    id={"annulla"}
                    typeModal="modalOscura"
                    disabled={
                        SessioneUtente.getInstance().ruoliUtente ===
                            Ruoli.Operatore_Laboratorio.descrizione ||
                        this.state.disabledTableButtons ||
                        (this.state.segnalazioneSelezionata &&
                            (this.state.segnalazioneSelezionata
                                .statoSegnalazione ===
                                OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                    .codice ||
                                this.state.segnalazioneSelezionata
                                    .statoValidazione ===
                                    OggettiUtili.statoValidazioneByLabel
                                        .Validata.codice ||
                            this.state.segnalazioneSelezionata.idSegnalazione === "null     null"))
                    }
                    modalText={t("Messages.ERR_01_07_0A_0A")}
                    text={t("Buttons.store")}
                    title={t("GestioneSegnalazioni.ricerca.archivia")}
                    style={{ height: "3rem", marginTop: "1rem", width: "100%" }}
                    confirmFun={this.archiviaSegnalazione}
                />
            </div>
        );

        const buttonDiv = (
            <div className={"row"}>
                <Button
                    id={"idButtonClean"}
                    text={t("Buttons.clean")}
                    disabled={this.controllaCampi()}
                    onClick={this.pulisciTutto}
                    className={[
                        whiteButton,
                        "col-sm-12 col-lg-3 mx-lg-auto",
                    ].join(" ")}
                    style={{ height: "3rem", marginTop: "1rem" }}
                ></Button>
                <Button
                    id={"idButtonSearch"}
                    text={t("Buttons.search")}
                    disabled={this.state.disabledButtons}
                    onClick={this.executeSearch}
                    className={[
                        bluButton,
                        "col-sm-12 col-lg-3 mx-lg-auto",
                    ].join(" ")}
                    style={{ height: "3rem", marginTop: "1rem" }}
                ></Button>
                {Utils.checkFunzionalitaByRuolo("idButtonInsertNeew") ? (
                    <Button
                        id={"idButtonInsertNeew"}
                        text={t("Buttons.insert_new")}
                        disabled={!this.state.disabledTableButtons}
                        onClick={this.inserisciNuova}
                        className={[
                            whiteButton,
                            "col-sm-12 col-lg-3 mx-lg-auto",
                        ].join(" ")}
                        style={{ height: "3rem", marginTop: "1rem" }}
                    ></Button>
                ) : null}
            </div>
        );

        return (
            <div className={styles.contenitore}>
                {ToasterSingleton.instance().renderToaster()}
                {form}

                <div className={styles.mandatoryColor}>
                    {t("GestioneSegnalazioni.ricerca.legenda_obbligatorio")}
                </div>

                {this.state.loading ? <div>{spinnerDiv}</div> : <div />}

                {buttonDiv}

                {this.state.showTable ? (
                    <div>
                        {" "}
                        {tableDiv} {tableButtonsDiv}
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    }
}

export default withTranslation("common")(RicercaSegnalazioni);
